<template>
  <div
    class="pop"
    :style="{
      display: dialogShow ? 'block' : 'none',
      'z-index': 201,
    }"
    :class="{
      'bs-guide': isGuide,
      mask: !isGuide,
      pcweixin: isWeixin && isPC,
    }"
    @click="dialogShow = false"
  >
    <div
      class="box pay-box"
      :class="{
        wechatpay: payTypeTab == 'wx',
        alipay: payTypeTab == 'alipay' || payTypeTab == 'huabei',
        huabei: payTypeTab == 'huabei',
      }"
      v-show="!isGuide"
      @click.stop
    >
      <div class="c-title">
        {{
          productList.length
            ? productList[value].label
            : data.productName || "购买"
        }}
      </div>
      <div class="content">
        <div class="pay-tab">
          <ul
            :class="{
              'item-3': isShowHuabei || isShowHuabeiNormal,
              'item-2': !isShowHuabei && !isShowHuabeiNormal,
            }"
          >
            <li
              :class="{
                checked: payTypeTab == 'wx',
              }"
              data-type="wx"
              @click="changPayType('wx')"
            >
              <input
                type="radio"
                name="pay-tab"
                :checked="payTypeTab == 'wx'"
              />
              <div class="text">微信支付</div>
            </li>
            <li
              :class="{
                checked: payTypeTab == 'alipay',
              }"
              data-type="alipay"
              @click="changPayType('alipay')"
            >
              <input
                type="radio"
                name="pay-tab"
                :checked="payTypeTab == 'alipay'"
              />
              <div class="text">支付宝</div>
            </li>
            <li
              :class="{
                checked: payTypeTab == 'huabei',
              }"
              data-type="huabei"
              @click="changPayType('huabei')"
              v-show="isShowHuabei || isShowHuabeiNormal"
            >
              <input
                type="radio"
                name="pay-tab"
                :checked="payTypeTab == 'huabei'"
              />
              <div class="text">
                {{ isShowHuabeiNormal ? "花呗" : "花呗分期" }}
              </div>
            </li>
          </ul>
        </div>
        <div class="pay-tabview">
          <!-- <div class="name">电脑版·月卡</div> -->
          <div class="name">
            <el-select v-if="productKey" v-model="value" placeholder="请选择">
              <el-option
                v-for="item in productList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div
            :class="{
              checked: payTypeTab == 'wx',
            }"
            class="payway"
            v-if="!isWeixin"
            @click="mobileChangePayType('wx')"
          >
            <input
              type="radio"
              data-type="wx"
              name="payway"
              :checked="payTypeTab == 'wx'"
            />
            <div class="check"></div>
            <img src="../assets/pic/icon-wechatpay.png" alt="微信支付" />
            <span>微信支付</span>
          </div>
          <div
            :class="{
              checked: payTypeTab == 'alipay',
            }"
            class="payway"
            v-if="!isWeixin"
            @click="mobileChangePayType('alipay')"
          >
            <input
              type="radio"
              data-type="alipay"
              name="payway"
              :checked="payTypeTab == 'alipay'"
            />
            <div class="check"></div>
            <img src="../assets/pic/icon-alipay.png" alt="支付宝" />
            <span>支付宝</span>
          </div>
          <div
            :class="{
              checked: payTypeTab == 'huabei',
            }"
            class="payway"
            v-show="(isShowHuabei || isShowHuabeiNormal) && !isWeixin"
            @click="mobileChangePayType('huabei')"
          >
            <input
              type="radio"
              data-type="huabei"
              name="payway"
              :checked="payTypeTab == 'huabei'"
            />
            <div class="check"></div>
            <img src="../assets/pic/icon-huabei.png" alt="支付宝" />
            <span>{{ isShowHuabeiNormal ? "花呗" : "花呗分期" }}</span>
          </div>
          <div class="huabei" v-show="isShowHuabei && payTypeTab == 'huabei'">
            <ul>
              <li
                :class="{
                  checked: hbFqNum == 3,
                }"
                @click="changeFqNum(3)"
              >
                <input
                  type="radio"
                  name="huabei"
                  data-fqnum="3"
                  :checked="hbFqNum == 3"
                />
                <div class="text">
                  <h3>
                    ￥{{ Math.floor((computedPrice * 100) / 3) / 100 }} x 3期
                  </h3>
                  <p>免手续费</p>
                </div>
              </li>
              <li
                :class="{
                  checked: hbFqNum == 6,
                }"
                @click="changeFqNum(6)"
              >
                <input
                  type="radio"
                  data-fqnum="6"
                  name="huabei"
                  :checked="hbFqNum == 6"
                />
                <div class="text">
                  <h3>
                    ￥{{ Math.floor((computedPrice * 100) / 6) / 100 }} x 6期
                  </h3>
                  <p>免手续费</p>
                </div>
              </li>
              <li
                :class="{
                  checked: hbFqNum == 12,
                }"
                @click="changeFqNum(12)"
              >
                <input
                  type="radio"
                  data-fqnum="12"
                  name="huabei"
                  :checked="hbFqNum == 12"
                />
                <div class="text">
                  <h3>
                    ￥{{
                      Math.floor(
                        (computedPrice * 100 * 0.075) / 12 +
                          (computedPrice * 100) / 12
                      ) / 100
                    }}
                    x 12期
                  </h3>
                  <p>
                    含手续费￥{{
                      Math.floor((computedPrice * 100 * 0.075) / 12) / 100
                    }}/期
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div
            class="pay-button"
            v-if="!isWeixin"
            @click="createMobilePayOrder(data.channel)"
          >
            去支付
          </div>
          <div
            class="block-tag warning"
            style="text-align: center"
            v-if="descList[descType]"
          >
            {{ descType ? descList[descType][value] : "" }}
          </div>
          <div
            class="qrcode"
            :class="{
              loading:
                !payInfo[data.pkey] ||
                (payInfo[data.pkey] && !payInfo[data.pkey][payTypeTab]) ||
                (payInfo[data.pkey] &&
                  payInfo[data.pkey][payTypeTab] &&
                  !payInfo[data.pkey][payTypeTab][data.hb_fq_num]),
            }"
          >
            <qrcode
              :value="
                payInfo[data.pkey] &&
                  payInfo[data.pkey][payTypeTab] &&
                  payInfo[data.pkey][payTypeTab][data.hb_fq_num] &&
                  payInfo[data.pkey][payTypeTab][data.hb_fq_num].qrcode
              "
              :options="{ size: 200 }"
              class="scan-code-img"
            ></qrcode>
          </div>
          <div class="price">￥{{ Number(computedPrice) }}</div>
          <div class="teach">
            <div class="img-box"></div>
            <div class="info"></div>
          </div>
          <div class="actions" v-if="isWeixin && !isPC">
            <button class="button" @click="orderPay('click')">购买</button>
          </div>
        </div>
      </div>
      <div class="result-info">
        <div class="desc">正在使用「{{ payType }}」付款 ...</div>
        <a href="#" class="button">我已付款</a>
      </div>
      <div class="close" @click="dialogShow = false"></div>
    </div>
  </div>
</template>

<script>
import {
  getFeatureProducts,
  createFcodeOrder,
  checkFcodeOrder,
  createMobileWxPay,
  createMobileAliPay,
  createWechatPay,
  createWechatPayOrder,
  getWechatSdk,
} from "@/api/index";
import { mapState } from "vuex";
import { Message } from "element-ui";
import qrcode from "@xkeshi/vue-qrcode";

let payText = {
  wx: "微信",
  alipay: "支付宝",
  huabei: "花呗",
};

export default {
  components: {
    qrcode,
  },
  data() {
    return {
      timer: null,
      dialogShow: false,
      orderData: {},
      payType: "微信",
      payTypeTab: "wx",
      payInfo: {},
      data: {},
      value: 0,
      products: [],
      productKey: "",
      productList: [],
      productPrice: [],
      isShowHuabei: false,
      isShowHuabeiNormal: false,
      hbfqList: [],
      hbFqNum: 3,
      isGuide: false,
      descType: "",
      descList: {
        privateLetter: [
          "赠送叠加包1500条",
          "赠送叠加包6000条",
          "赠送叠加包26000条",
          "赠送叠加包300条",
        ],
      },
    };
  },
  props: {
    ticket: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState({
      isPC: (state) => state.isPC,
      isElectron: (state) => state.isElectron,
      isWeixin: (state) => state.isWeixin,
    }),
    computedPrice() {
      console.log(this.value);
      return (
        this.data.price ||
        (this.productList.length
          ? this.productList[this.value].price / 100
          : this.payInfo[this.data.pkey] &&
            this.payInfo[this.data.pkey][this.payTypeTab] &&
            this.payInfo[this.data.pkey][this.payTypeTab] &&
            this.payInfo[this.data.pkey][this.payTypeTab][this.data.hb_fq_num]
              .price)
      );
    },
  },
  watch: {
    value() {
      this.orderPay();
    },
    hbFqNum() {
      if (this.isPC || this.isElectron) {
        this.createOrder();
      }
    },
    dialogShow(val) {
      if (!val) {
        this.descType = "";
        this.isGuide = false;
        this.clearCountDown();
      } else {
        this.value = 0;
        this.payTypeTab = "wx";
        this.hbFqNum = 3;
      }
    },
    payTypeTab: {
      handler: function(val) {
        console.log(val);
        if (val == "huabel") {
        }
      },
    },
    computedPrice(val) {
      console.log(this.data);
      if (val >= 89 && val <= 358) {
        this.isShowHuabei = true;
      } else {
        this.isShowHuabei = false;
      }
      if (val < 89) {
        this.isShowHuabeiNormal = true;
      } else {
        this.isShowHuabeiNormal = false;
      }
      console.log(1);
    },
  },
  mounted() {
    if (this.isWeixin) {
      getWechatSdk(
        {
          url: location.href,
        },
        { notify: false }
      ).then((res) => {
        let data = res.data;
        wx.config({
          debug: data.debug,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: data.jsApiList,
        });
      });
    }
  },
  methods: {
    orderPay(eventtype = "") {
      if (this.isWeixin && !this.isPC && eventtype != "click") {
        this.data.price = this.productPrice[this.value] * 1;
        this.data.productName = !!~this.productKey.indexOf("robot")
          ? "增购机器人"
          : 0;
        return;
      }
      let type =
        this.productKey == "cloud_in" ||
        this.productKey == "guessnum" ||
        this.productKey == "beggift" ||
        this.productKey == "duty" ||
        this.productKey == "guessProvince" ||
        this.productKey == "privateLetter"
          ? 1
          : 0;
      type = !!~this.productKey.indexOf("robot") ? 2 : type;
      type = !!~this.productKey.indexOf("private_chat_count") ? 3 : type;
      this.showDialog({
        pkey: this.productList[this.value].pkey,
        num: 1,
        channel: this.data.channel,
        type: type,
        email: "",
        ticket: this.ticket,
        price: this.productPrice[this.value] * 1,
        productName: !!~this.productKey.indexOf("robot") ? "增购机器人" : 0,
      });
    },
    changPayType(val) {
      this.payTypeTab = val;
      if (val == "huabei") {
        this.data.channel = "alipay";
      } else {
        this.data.channel = val;
      }
      this.createOrder();
      this.payType = payText[val];
    },
    mobileChangePayType(val) {
      this.payTypeTab = val;
      if (val == "huabei") {
        this.data.channel = "alipay";
      } else {
        this.data.channel = val;
      }
      this.payType = payText[val];
    },
    orderPayWeixinGuideShow() {
      this.isGuide = true;
      this.dialogShow = true;
    },
    showDialogOfBuy(pkey, descType = "") {
      this.productKey = pkey;
      this.descType = pkey;
      this.data.channel = "wx";
      getFeatureProducts({ productKey: pkey }).then((res) => {
        if (res.code === 0) {
          this.products = res.data.products;
          let list = [];
          let pricelist = [];
          this.products.forEach((val, index) => {
            list.push({
              value: index,
              label: val.name.replace("猜数字", "猜点数"),
              price: val.price,
              pkey: val.pkey,
            });

            pricelist.push(Number(val.price) / 100);
            if (this.products.length == index + 1) {
              this.productList = list;
              this.productPrice = pricelist;
              if (list.length) {
                this.orderPay();
              }
            }
          });
        }
      });
      this.dialogShow = true;
    },
    showDialog(json) {
      this.payType = payText[json.channel];
      this.dialogShow = true;
      this.data = json;
      // this.payTypeTab = json.channel;
      let self = this;
      if (this.isWeixin && !this.isPC) {
        createWechatPayOrder(json).then((res) => {
          if (res.code == 1000) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>创建订单失败</strong><p style="margin-top: 5px;">错误码「1000」，请联系客服</p>',
            });
          }
          if (res.code == 20001) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>商品不存在</strong><p style="margin-top: 5px;">错误码「20001」，请联系客服</p>',
            });
          }
          let orderId = res.data.orderId;
          createWechatPay({
            order_id: orderId,
          }).then((payData) => {
            if (payData.code == 70003) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>微信登录授权过期</strong><p style="margin-top: 5px;">请刷新，重新登录配置后台</p>',
              });
            }
            if (payData.code == 1000) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>创建公众号订单失败</strong><p style="margin-top: 5px;">错误码「1000」，请联系客服</p>',
              });
            }
            if (payData.code == 0) {
              let data = payData.data;
              wx.chooseWXPay({
                timestamp: data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
                package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: data.paySign, // 支付签名
                success: function(res) {
                  // 支付成功后的回调函数
                  self.checkFcodeOrder(orderId);
                },
              });
            }
          });
        });
        return;
      }
      if (this.isPC || this.isElectron || (this.isWeixin && this.isPC)) {
        this.createOrder();
      }
    },
    createMobilePayOrder(val) {
      if (this.isShowHuabei && this.payTypeTab == "huabei") {
        this.data.hb_fq_num = this.hbFqNum;
      } else {
        this.data.hb_fq_num = 0;
      }
      if (this.isShowHuabeiNormal && this.payTypeTab == "huabei") {
        this.data.enable_pay_channels = "pcredit";
      } else {
        this.data.enable_pay_channels = "";
      }
      this.data.channel = val;
      if (val === "wx") {
        createMobileWxPay(this.data).then((res) => {
          if (res.code === 0) {
            let mwebUrl = res.data.mweb_url;
            let orderId = res.data.orderId;
            location.href = `${mwebUrl}&redirect_url=${encodeURIComponent(
              `${location.href}?orderId=${orderId}`
            )}`;
          }
          if (res.code == 1000) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>创建微信H5订单失败</strong><p style="margin-top: 5px;">错误码「1000」，请联系客服</p>',
            });
          }
          if (res.code == 20001) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>商品不存在</strong><p style="margin-top: 5px;">错误码「20001」，请联系客服</p>',
            });
          }
        });
      }
      if (val === "alipay") {
        this.data.return_url = location.href;
        createMobileAliPay(this.data).then((res) => {
          if (res.code === 0) {
            location.href = res.data.mweb_url;
          }
          if (res.code == 1000) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>创建支付宝H5订单失败</strong><p style="margin-top: 5px;">错误码「1000」，请联系客服</p>',
            });
          }
          if (res.code == 20001) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>商品不存在</strong><p style="margin-top: 5px;">错误码「20001」，请联系客服</p>',
            });
          }
        });
      }
    },
    createOrder() {
      // let hbPkey = {
      //   b_year: "b_year_fq",
      //   b_season: "b_season_fq",
      //   m_season: "m_season_fq",
      //   m_year: "m_year_fq",
      // };
      // let nmPeky = {
      //   b_year_fq: "b_year",
      //   b_season_fq: "b_season",
      //   m_season_fq: "m_season",
      //   m_year_fq: "m_year",
      // };
      // let hbPrice = {
      //   b_year: 330,
      //   b_season: 90,
      //   m_season: 210,
      //   m_year: 770,
      // };
      // let nmPrice = {
      //   b_year_fq: 328,
      //   b_season_fq: 89,
      //   m_season_fq: 209,
      //   m_year_fq: 768,
      // };
      let pkey = this.data.pkey;
      console.log(pkey);
      setTimeout(() => {
        if (this.isShowHuabei && this.payTypeTab == "huabei") {
          this.data.hb_fq_num = this.hbFqNum;
        } else {
          this.data.hb_fq_num = 0;
        }
        // if (this.payTypeTab == "huabei") {
        //   this.data.price = hbPrice[pkey] || this.data.price;
        //   this.data.pkey = hbPkey[pkey] || this.data.pkey;
        // } else {
        //   this.data.price = nmPrice[pkey] || this.data.price;
        //   this.data.pkey = nmPeky[pkey] || this.data.pkey;
        // }
        this.$forceUpdate();
        if (this.isShowHuabeiNormal && this.payTypeTab == "huabei") {
          this.data.enable_pay_channels = "pcredit";
        } else {
          this.data.enable_pay_channels = "";
        }
        if (
          this.payInfo[this.data.pkey] &&
          this.payInfo[this.data.pkey][this.payTypeTab] &&
          this.payInfo[this.data.pkey][this.payTypeTab][this.data.hb_fq_num]
        ) {
          this.countDownStart(
            this.payInfo[this.data.pkey][this.payTypeTab][this.data.hb_fq_num]
          );
          return;
        }
        createFcodeOrder(this.data).then((res) => {
          if (res.code === 0) {
            this.orderData = res.data;
            let time = parseInt(
              (+new Date() + 3 * 60 * 1000 - +new Date()) / 1000
            );
            // this.data.channel == 'wx'
            //   ? (this.wxTimeExpire = time)
            //   : (this.alipayTimeExpire = time)
            // this.data.channel == 'wx'
            //   ? (this.wxScan = res.data.qrcode)
            this.payInfo[this.data.pkey] = this.payInfo[this.data.pkey] || {};
            this.payInfo[this.data.pkey][this.payTypeTab] =
              this.payInfo[this.data.pkey][this.payTypeTab] || {};
            this.payInfo[this.data.pkey][this.payTypeTab][this.data.hb_fq_num] =
              this.payInfo[this.data.pkey][this.payTypeTab][
                this.data.hb_fq_num
              ] || {};
            this.payInfo[this.data.pkey][this.payTypeTab][
              this.data.hb_fq_num
            ].timeExpire = time;
            this.payInfo[this.data.pkey][this.payTypeTab][
              this.data.hb_fq_num
            ].qrcode = res.data.qrcode;
            this.payInfo[this.data.pkey][this.payTypeTab][
              this.data.hb_fq_num
            ].orderId = res.data.orderId;
            this.payInfo[this.data.pkey][this.payTypeTab][
              this.data.hb_fq_num
            ].price = res.data.price;
            this.$forceUpdate();
            this.countDownStart(
              this.payInfo[this.data.pkey][this.payTypeTab][this.data.hb_fq_num]
            );
          }
          if (res.code == 1000) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>创建订单失败</strong><p style="margin-top: 5px;">错误码「1000」，请联系客服</p>',
            });
          }
          if (res.code == 20001) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>商品不存在</strong><p style="margin-top: 5px;">错误码「20001」，请联系客服</p>',
            });
          }
          if (res.code == 22001) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>创建订单失败</strong><p style="margin-top: 5px;">订单生成超时，请联系客服</p>',
            });
          }
        });
      }, 0);
    },
    hideDialog() {
      this.dialogShow = false;
    },
    clearCountDown() {
      this.productKey = "";
      this.productList = [];
      this.payInfo = {};
      this.cleanCountDown();
    },
    countDownStart(payInfo) {
      this.cleanCountDown();
      this.timer = setInterval(() => {
        if (payInfo.timeExpire) {
          // payInfo.timeExpire--
          if (payInfo.timeExpire <= 0) {
            payInfo.qrcode = "";
            payInfo.timeExpire = 0;
          }
        }
        this.checkFcodeOrder(payInfo.orderId);
      }, 3e3);
    },
    cleanCountDown() {
      clearInterval(this.timer);
      this.timer = null;
    },
    checkFcodeOrder(orderId) {
      checkFcodeOrder({
        orderId,
      }).then((res) => {
        if (res.code === 0) {
          if (res.data.paid) {
            this.dialogShow = false;
            if (!this.dialogShow) {
              Message({
                showClose: true,
                message: "支付成功！",
                duration: 0,
                type: "success",
              });
            }
            this.cleanCountDown();
            if (/cloud_bot/i.test(this.data.pkey)) {
              this.$emit("robotAdd");
              return;
            }
            if (res.data.fcodes) {
              this.$emit("payCompleted", res.data.fcodes, this.data.pkey);
            } else {
              this.$emit("payCompleted", [], this.data.pkey);
            }
          }
        }
      });
    },
    changeFqNum(fqNum) {
      this.hbFqNum = fqNum;
    },
  },
};
</script>
